import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IPresencePoints } from "interfaces";
import { PresencePointsForm } from "components/forms";

export const PresencePointsEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IPresencePoints>();
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <PresencePointsForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Edit>
  );
};
